






















































































import { check, logout } from '@/api/auth';
import { Component, Vue } from 'vue-property-decorator';
import { AuthModule } from '@/store/modules/Auth';

@Component
export default class App extends Vue {
  private logoutDialog = false;
  private cards = ['Today', 'Yesterday'];
  private drawer = null;
  public loading = true;

  // eslint-disable-next-line class-methods-use-this
  public async created() {
    // eslint-disable-next-line prefer-rest-params
    console.log(arguments);
    const ret = await check();
    if (ret.success) {
      await AuthModule.login({
        type: ret.data.type,
        name: ret.data.name,
        sp: ret.data.sp,
      });
      this.loading = false;
    }
  }

  private onClickTop() {
    this.$router.push('/');
  }

  private async onLogout() {
    await logout();
    AuthModule.logout();
    if (AuthModule.sp) {
      this.$router.push('/login?sp=1');
    } else {
      this.$router.push('/login');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  private get name() {
    return AuthModule.name;
  }

  // eslint-disable-next-line class-methods-use-this
  private get isSp() {
    return AuthModule.sp;
  }
}
